<template>
  <v-dialog
    id="directions-component"
    content-class="fdi-quiz-modal"
    class="border-radius-15"
    persistent
    max-width="280"
    v-model="directionDialog"
  >
    <v-card color="rgba(0, 0, 0, 0.9)" class="border-radius-15 modal-class">
      <v-container id="directions-image-container">
        <v-img :src="step.url.url" max-width="100%"/>
      </v-container>
      <v-card-actions class="modal-actions">
        <v-btn flat @click.native="goBack">
          <v-img :src="backButton"/>
        </v-btn>
        <v-spacer></v-spacer>
        <v-img width="85px" :src="arrivedButton" @click.native="clickArrived"/>
        <v-spacer></v-spacer>
        <v-btn flat disabled :style="{opacity: .3}">
          <v-img :src="hintButton"/>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Store from "@/store";
import backButton from "../../assets/directions/back_button.png";
import arrivedButton from "../../assets/directions/arrived_button.png";
import hintButton from "../../assets/directions/hint_button.png";

export default {
  name: "directions-component",
  props: {
    step: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {},
  data() {
    return {
      directionDialog: true,
      helpDialog: false,
      backButton: backButton,
      arrivedButton: arrivedButton,
      hintButton: hintButton
    };
  },
  methods: {
    clickArrived() {
      this.goForward();
    },
    closeAllDialogs() {
      this.answerDialog = false;
      this.incorrectDialog = false;
      this.correctDialog = false;
      this.helpDialog = false;
      this.hintDialog = false;
      this.giveUpDialog = false;
    },
    openHint(index) {
      this.closeAllDialogs();
      this.openHintIndex = index;
      this.hintDialog = true;
    },
    closeHintToHelp() {
      this.closeAllDialogs();
      this.helpDialog = true;
      this.openHintIndex = null;
    },
    closeHintToQuestion() {
      this.closeAllDialogs();
      this.answerDialog = true;
      this.openHintIndex = null;
    },
    goBack() {
      this.closeAllDialogs();
      this.$store.dispatch("decrementStep");
    },
    goForward() {
      this.closeAllDialogs();
      this.$store.dispatch("incrementStep");
    },
    tryAgain() {
      this.closeAllDialogs();
      this.answerDialog = true;
    },
    getHelp() {
      this.closeAllDialogs();
      this.helpDialog = true;
    },
    giveUp() {
      this.closeAllDialogs();
      this.giveUpDialog = true;
    }
  },
  computed: {
    contentHeight() {
      return window.innerHeight - 500;
    }
  }
};
</script>

<style>
#directions-image-container {
  position: absolute;
  bottom: 65px;
  top: 0;
}

#directions-message {
  top: -150px;
  position: absolute;
  font-family: "BebasNeue-Regular";
}

.v-messages {
  color: red;
}

.trans-background {
}

.border-radius-5 {
  border-radius: 5px;
}

.border-radius-15 {
  border-radius: 15px;
}

.modal-actions {
  position: absolute;
  width: 100%;
  bottom: 10px;
}

.v-overlay--active::before {
  background-color: white;
  opacity: 0.85;
}
</style>
